import axios from "axios";

export const API_REQUEST = "API_REQUEST";
export const API_SUCCESS = "API_SUCCESS";
export const API_ERROR = "API_ERROR";

export const apiRequest = ({ body, method, url, feature, params }) => ({
  type: `${feature} ${API_REQUEST}`,
  payload: { body, method, url, feature, params },
});

export const apiSuccess = ({ response, feature }) => ({
  type: `${feature} ${API_SUCCESS}`,
  payload: response.data,
  token: response.headers["x-recover_token"],
  meta: { feature },
});

export const apiError = ({ error, feature }) => ({
  type: `${feature} ${API_ERROR}`,
  payload: error,
  meta: { feature },
});

export const apiMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);

    if (action.type.includes(API_REQUEST)) {
      let { body, url, method, feature, params } = action.payload;

      if (window.token) {
        if (!params) {
          params = {};
        }
        params.recover_token = window.token;
      }

      axios({
        method: method,
        url: url,
        params: params,
        data: body,
      })
        .then((response) => {
          const successLocation = response.headers["x-location"];
          if (successLocation) {
            window.location.href = successLocation;
          } else dispatch(apiSuccess({ response, feature }));
        })
        .catch((error) => {
          dispatch(apiError({ error, feature }));
        });
    }
  };
